import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { Layout, Title } from 'common/components/layout';
import { getCustomerCreditCard } from 'redux/customerCreditCards/actions';

import EditRegularCreditCard from './edit/EditRegularCreditCard';

const Edit = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const settings = useSelector((state) => state.setting.data);
  const customerCreditCardReducer = useSelector(
    (state) => state.customerCreditCard
  );

  useEffect(() => {
    dispatch(getCustomerCreditCard(params.id));
  }, [dispatch, params.id]);

  if (!settings || !customerCreditCardReducer.data) {
    return (
      <Layout title="Edit Credit Card" loading>
        <Title>Your Account</Title>
      </Layout>
    );
  }

  return <EditRegularCreditCard />;
};

export default Edit;
